import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-help-statistics',
  imports: [MatIconModule],
  templateUrl: './help-statistics.component.html',
  styleUrls: ['./help-statistics.component.css'],
})
export class HelpStatisticsComponent {}
